// Text catalog for the Samarbejdspartnere / Business partners page.
// The partner logo data array lives in src/pages/SamarbejdspartnerePage.tsx
// (only text is translated here; logo image paths stay with the component).

import { type Locale } from "../config";
import { type PageMeta } from "../head";

type SamarbejdspartnereStrings = {
  meta: PageMeta;
  hero: { eyebrow: string; title: string; body: string };
  list: { heading: string; body: string };
  quote: { text: string; name: string; role: string };
  cta: { heading: string; button: string };
};

export const samarbejdspartnereStrings: Record<Locale, SamarbejdspartnereStrings> = {
  da: {
    meta: {
      title: "Samarbejdspartnere - MI Support",
      description:
        "Se et udpluk af de virksomheder, MI Support har samarbejdet med i over 25 år – inden for pharma, kemi, energi, fødevarer og infrastruktur.",
    },
    hero: {
      eyebrow: "Referencer",
      title: "Samarbejdspartnere",
      body: "MI Support har i mange år hjulpet både mindre og større organisationer med at realisere deres byggeprojekter. Som eksperter bruger vi vores brancheerfaring og ekspertviden til at bringe vores kunders visioner til live og til at sikre, at strategien bliver eksekveret til den rette kvalitet, tid og økonomi.",
    },
    list: {
      heading: "Se vores samarbejdspartnere",
      body: "MI Support har i mere end 25 år haft samarbejder på en lang række spændende projekter inden for industrier såsom farma, kemi, energi og fødevarer, og vi har det fortsat den dag i dag. Se et udpluk af vores gode samarbejdspartnere her.",
    },
    quote: {
      text: "Vi er stolte over at have løst opgaver for en lang række gode samarbejdspartnere i tidens løb, fra mindre byggerier til større prestigeprojekter.",
      name: "Sonny Christensen",
      role: "Stifter & ejer af MI Support",
    },
    cta: {
      heading: "Skal vi starte et nyt samarbejde?",
      button: "Kontakt os",
    },
  },

  en: {
    meta: {
      title: "Business partners - MI Support",
      description:
        "See a selection of MI Support's business partners across pharma, chemistry, energy and food for more than 25 years.",
    },
    hero: {
      eyebrow: "References",
      title: "Business partners",
      body: "For many years MI Support has helped both smaller and larger organisations realise their construction projects. As experts, we use our industry experience and specialist knowledge to bring our customers' visions to life and to ensure that the strategy is executed to the right quality, time and economy.",
    },
    list: {
      heading: "See our business partners",
      body: "For more than 25 years MI Support has collaborated on a wide range of exciting projects within industries such as pharma, chemistry, energy and food, and we still do so today. See a selection of our great business partners here.",
    },
    quote: {
      text: "We are proud to have solved tasks for a wide range of great business partners over time, from smaller constructions to larger prestige projects.",
      name: "Sonny Christensen",
      role: "Founder & owner of MI Support",
    },
    cta: {
      heading: "Shall we start a new partnership?",
      button: "Contact us",
    },
  },

  de: {
    meta: {
      title: "Unsere Geschäftspartner - MI Support",
      description:
        "Sehen Sie eine Auswahl der Geschäftspartner von MI Support in den Bereichen Pharma, Chemie, Energie und Lebensmittel seit mehr als 25 Jahren.",
    },
    hero: {
      eyebrow: "Referenzen",
      title: "Geschäftspartner",
      body: "MI Support hilft seit vielen Jahren sowohl kleineren als auch größeren Organisationen, ihre Bauprojekte zu verwirklichen. Als Experten nutzen wir unsere Branchenerfahrung und unser Fachwissen, um die Visionen unserer Kunden zum Leben zu erwecken und sicherzustellen, dass die Strategie in der richtigen Qualität, Zeit und Wirtschaftlichkeit umgesetzt wird.",
    },
    list: {
      heading: "Sehen Sie unsere Geschäftspartner",
      body: "MI Support arbeitet seit mehr als 25 Jahren an einer Vielzahl spannender Projekte in Branchen wie Pharma, Chemie, Energie und Lebensmitteln zusammen – und tut dies bis heute. Sehen Sie hier eine Auswahl unserer guten Geschäftspartner.",
    },
    quote: {
      text: "Wir sind stolz darauf, im Laufe der Zeit Aufgaben für eine Vielzahl guter Geschäftspartner gelöst zu haben – von kleineren Bauten bis hin zu größeren Prestigeprojekten.",
      name: "Sonny Christensen",
      role: "Gründer & Inhaber von MI Support",
    },
    cta: {
      heading: "Sollen wir eine neue Zusammenarbeit beginnen?",
      button: "Kontaktieren Sie uns",
    },
  },
};
